var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"responsive-embed-wrap",style:({ maxWidth: _vm.maxWidth + 'px' })},[_c('div',{staticClass:"responsive-embed",style:({ paddingTop: (1/_vm.ratio * 100) + '%' })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }